import { render, staticRenderFns } from "./importPlane.vue?vue&type=template&id=6c6d4df0"
import script from "./importPlane.vue?vue&type=script&lang=js"
export * from "./importPlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports